import { Pagination } from '@mui/material';
import { MoreHorizontal } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { checkTagValidity } from '../../Utils/Utils';
import { ADD_EQUIP, DELETE_EQUIP, UPDATE_EQUIP } from '../../Utils/constant';
import { Loader } from '../../components/Widget/Loader';
import { deleteOne, store, updateOne } from '../../services/service';
import { useStoreEquipement } from '../../store/Paramettre/equipementStore';

export const TypeEquipement = () => {
    const [updateItem, selectUpdateItem] = useState(null);
    const [designation, setDesignation] = useState('')
    const [item, setItem] = useState()
    const [cout, setCout] = useState('')
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);
    const typeEquipements = useStoreEquipement()
    const submit = (data) => {
        setIsSubmit(true)
        updateItem === null ?
            store(ADD_EQUIP, 'application/json', data).then((res) => {
                setIsSubmit(false);
                if (res.status === 200) {
                    reset();
                    selectUpdateItem(null)
                    setDesignation('')
                    setCout('')
                    document.getElementById('fermer_create_trajet').click()
                    toast.success('Equipement ajouté')
                    typeEquipements.equipement({ page: 0, param: "", size: 10 })
                }

            }).catch((err) => {
                setIsSubmit(false)
                toast.error(err.response.data.donnee)

            }) : updateOne(UPDATE_EQUIP, updateItem.id, data).then((res) => {
                setIsSubmit(false);
                if (res.status === 200) {
                    reset();
                    selectUpdateItem(null)
                    setDesignation('')
                    setCout('')
                    document.getElementById('fermer_create_trajet').click()
                    toast.success('Type equipement mis à jour')
                    typeEquipements.equipement({ page: 0, param: "", size: 10 })
                }
            }).catch((err) => {
                setIsSubmit(false)
                toast.error(err.response.data.donnee)

            })
    }
    useEffect(() => {
        typeEquipements.equipement({ page: 0, param: "", size: 10 })
        reset();
    }, [])

    useEffect(() => {
        if (updateItem) {
            reset();
        }
    }, [updateItem, reset]);

    const more = (page) => {
        typeEquipements.equipement({ page: page - 1, param: "", size: 10 })
    }
    
    return (
        <>
            <div>
                <div className='mt-4 lg:flex item-center '>
                    {/* <h1 className="text-2xl font-extrabold text-black">Type d'équipements</h1> */}
                    <input type="text" placeholder="Rechercher element..." className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                    />
                    <div className='ml-auto'>
                        {
                            checkTagValidity('AJOUTER _TYPE_EQUIPEMENT') ?
                                <button onClick={() => {
                                    reset()
                                    selectUpdateItem(null)
                                    document.getElementById('type_equip').showModal()
                                }} className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white" >
                                    Ajouter un type d'equipement
                                </button>
                                :
                                null
                        }
                        <dialog id="type_equip" className="modal ">
                            <div className="modal-box ">
                                <div className="modal-action">
                                    <h1 className='mr-auto text-2xl font-bold'>
                                        {updateItem === null ? "Ajouter un type d'equipement" : "Modification du type d'equipement"}
                                    </h1>
                                    <form method="dialog">
                                        <button
                                            id="fermer_create_trajet"
                                            className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold">
                                            ✕
                                        </button>
                                    </form>
                                </div>
                                <form onSubmit={handleSubmit(submit)} className='px-2'>
                                    <div className='my-4 space-y-4'>
                                        <div className='my-2'>
                                            <label htmlFor="" className='text-sm font-medium'>Designation <span className="text-red-500">*</span></label>
                                            <input  {...register('designation', { required: true })} type="text" placeholder="" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                                onChange={(e) => { setDesignation(e.target.value) }} value={designation} />

                                            {errors.designation && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                                        </div>
                                        <div className='my-2'>
                                            <label htmlFor="" className='text-sm font-medium'>Coût de l'équipement <span className="text-red-500">*</span></label>
                                            <input {...register('cout', { required: true })} type="number" placeholder="" className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                                                onChange={(e) => { setCout(e.target.value) }} value={cout} />
                                            {errors.cout && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                                        </div>

                                        <button type='submit'
                                            disabled={isSubmit ? true : false}
                                            className={`${!isSubmit
                                                ? "text-black bg-main"
                                                : "text-slate-800 bg-slate-200 "
                                                } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                                        >
                                            {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                                            {isSubmit ? (
                                                <span className="loading loading-dots loading-xs"></span>
                                            ) : null}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </dialog>
                    </div>
                </div>
                <div className='grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6 gap-2 my-8'>
                    {
                        typeEquipements?.data?.equipements?.length === 0 ? 'Aucune donnée' : typeEquipements?.data?.equipements?.length !== 0 && !typeEquipements?.loading ? (
                            typeEquipements?.data?.equipements?.map((item) => (
                                <div className='relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs text-center'>
                                    <div className="dropdown dropdown-end absolute right-2 top-2">
                                        <div
                                            tabIndex={0}
                                            role="button"
                                            className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                                        >
                                            <MoreHorizontal size={20} />
                                        </div>
                                        <ul
                                            tabIndex={0}
                                            className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                                        >
                                            <button
                                                className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                onClick={() => {
                                                    document.getElementById('type_equip').showModal()
                                                    selectUpdateItem(item)
                                                    setDesignation(item.designation)
                                                    setCout(item.cout)
                                                }
                                                }
                                            >
                                                Modifier
                                            </button>
                                            <button
                                                onClick={() => {
                                                    document.getElementById('delete_equipement').showModal()
                                                    setItem(item)
                                                }
                                                }
                                                className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                            >
                                                Supprimer
                                            </button>

                                        </ul>
                                    </div>
                                    <div className='bg-main w-10 h-10 rounded m-1 flex items-center justify-center'>
                                    </div>
                                    <div>
                                        <p className='truncate w-28'>{item.designation}</p>
                                        <p className='truncate w-28 font-bold'>{item.cout}</p>
                                    </div>

                                </div>

                            ))
                        ) :
                            <Loader />
                    }

                </div>
                <div className='my-3 flex justify-end'>
                    <Pagination onChange={(event, newValue) => more(newValue)}
                        onSelect={selectedPage => more(selectedPage)} count={typeEquipements.count} variant="outlined" color='primary' shape="rounded" />
                </div>
                <dialog id="delete_equipement" className="modal">
                    <div className="modal-box max-w-md rounded-lg">
                        <h3 className="font-extrabold text-xl text-red-600 ">
                            Attention
                        </h3>
                        <p className="pt-2 text-black font-medium">
                            Voulez vous vraiment effectuer cette action ?
                        </p>
                        <div className="modal-action">
                            <form
                                method="dialog"
                                className="w-full flex items-center justify-end gap-x-4"
                            >
                                <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                    Annuler
                                </button>
                                <button onClick={() => {
                                    deleteOne(DELETE_EQUIP, item.id).then(() => {
                                        typeEquipements.equipement({ page: 0, param: "", size: 10 })
                                        toast.success(`${item.designation + ' supprimé'}`)
                                    }).catch((err) => {

                                    })
                                }} className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                    Suppirmer
                                </button>
                            </form>
                        </div>
                    </div>
                </dialog>
            </div>

        </>
    )
}
